// extracted by mini-css-extract-plugin
export default {"VerificationProcess":"VerificationProcess_VerificationProcess__-iH-Z","VerificationProcessHead":"VerificationProcess_VerificationProcessHead__396oZ"};